import React from 'react';
import autobind from 'autobind-decorator';

import {service as RelationshipService} from '../../../../Services/RelationshipService';
import {StreamBankLink} from "../../StreamBankLink";

export class UpdateProjectStakeholdersActivityFeedItemDescription extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            relationships: []
        };
    }

    componentDidMount() {
        RelationshipService.Get()
            .then((x) => {
                this.setState({ relationships: x.result });
            });
    }

    @autobind
    getRelationship() {
        if(this.props.CustomEventData && this.props.CustomEventData.relationshipId) {
            let relationship = this.state.relationships.find(
                (x) => x.relationshipId == this.props.CustomEventData.relationshipId
            );

            if(relationship) {
                return relationship.name;
            }
        }

        return null;
    }

    @autobind
    getName() {
        return this.props.CustomEventData ? this.props.CustomEventData.stakeholderName : "";
    }

    @autobind
    getContactId() {
        return this.props.CustomEventData ? this.props.CustomEventData.stakeholderId : "";
    }

    @autobind
    getPhrase() {
        return this.props.CustomEventData && this.props.CustomEventData.action ? this.props.CustomEventData.action : "";
    }

    @autobind
    getLink() {
        return <StreamBankLink
            // if removed, they won't exist in the current context, so change to the root
            Context={this.getPhrase() === "removed" ? {} : null}
            Tool={"contacts/" + this.getContactId()}
        >
            {this.getName()}
        </StreamBankLink>;
    }

    render() {
        const { Event } = this.props;
        return <p>
            {Event?.Activity?.User?.name} {this.getPhrase()} a {this.getRelationship()} {this.getLink()}.
        </p>;
    }
}

